<template>
    <tr :class="'equipeSubItem '+ winClass">
        <td style="width:10%">{{numero==null ? '?' : parseInt(numero)+1}}</div>
        <td style="text-align:left;padding-left: 5px;width:40%" ><div class="pseudo">{{pseudo}}</div></div>
         <td style="text-align:center;width:5%" v-if="jouesC!=null">
           {{jouesC}}  
        </td>
        <td style="text-align:center;width:5%" v-if="winScoreC!=null">
            {{winScoreC}}  
        </td>
        <td style="text-align:center;width:10%" v-if="gaC!=null">
            {{gaC}}  
        </td>
        <td style="width:30%;">
             <div style="text-align:center;width:50%;display:inline-block" v-if="rangC!=null" >
             {{rangC}}
            </div>
            <div style="text-align:right;width:50%;display:inline-block">
                <span class="icon is-success" v-show="win">
                    <i class="fas fa-trophy"></i>
                </span> 
            </div>
       
        </td>
    </tr>
</template>
<style  scoped>
    .equipeSubItem {
        text-align: left;
        padding: 5px;
        width: 100%;
         background-color: white;
         color: black;
    }
    .pseudo {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 115px;
    }
    th {
        color: black;
        font-weight: bolder;
    }
    td {
         height: 50%;
         vertical-align: middle;
        
    }
    .winTeam {
        background-color: rgb(214, 240, 175);
       
    }
    .loseTeam {
        background-color: rgb(218, 218, 218);
        color: gray;
    }
</style>
<script>
export default {
    props: ['numero', 'tournoi', 'win', 'winScore', 'ga','joues','rang'],
    computed: {
        jouesC: {
            get() {
                if (typeof(this.joues)!="undefined") {
                    return this.joues;
                }
                else
                    return null;
            }
        },
        rangC: {
            get() {
                if (typeof(this.rang)=="undefined") {
                    return null;
                }
                else {
                    if (this.rang==1)
                        return "1er";
                    else if (this.rang!=null)
                        return this.rang + "ème";
                    else
                        return null;
                }
            }
        },
        winScoreC: {
            get() {
                if (typeof(this.winScore)!="undefined") {
                    return this.winScore;
                }
                else
                    return null;
            }
        },
        gaC: {
            get() {
                if (typeof(this.ga)!="undefined") {
                    return this.ga;
                }
                else
                    return null;
            }
        },
        winClass: {
            get() {
                if (this.win!=null) {
                    if (this.win) {
                        return 'winTeam';
                    }
                    else {
                        return 'loseTeam';
                    }
                }
                else
                    return '';
            }
        },
        pseudo: {
            get() {
                
                if (this.numero==null)
                    return "";
                else if (typeof(this.tournoi.joueurs[this.numero])=='undefined') {
                    return "Anonyme"
                }
                else {
                    if (typeof(this.tournoi.joueurs[this.numero].nameEquipe)!="undefined") {
                        if (this.tournoi.joueurs[this.numero].nameEquipe=="")
                            return this.tournoi.joueurs[this.numero].pseudo;
                        else
                            return this.tournoi.joueurs[this.numero].nameEquipe;
                    }
                    if (this.tournoi.joueurs[this.numero].pseudo!=null) 
                        return this.tournoi.joueurs[this.numero].pseudo;
                }
            }
        }
    }
}
</script>